function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#4d5056;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21,42A21,21,0,1,0,0,21,21,21,0,0,0,21,42Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M22,16.2a1,1,0,0,0-1-1,1.08,1.08,0,0,0-1,1,1,1,0,0,0,1,1A1.08,1.08,0,0,0,22,16.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M18.8,21.1c.1.7.9.7.9,0a6.8,6.8,0,0,1,.2-2v2.3h0c0,1.7,0,3.4-.1,5.2,0,.8,1,.8,1,0,0-1.3.1-2.7.1-4H21c0,1.3,0,2.7.1,4,0,.8,1,.8,1,0-.1-1.7-.1-3.4-.1-5.2V19.2a4.65,4.65,0,0,1,.3,2c-.1.7.8.7.9,0,.1-1.6-.4-3.6-1.9-3.7a.85.85,0,0,0-.7,0C19.1,17.6,18.7,19.6,18.8,21.1Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 13.4,
  y: 10.9,
  width: 1.1,
  height: 20.3
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 27.6,
  y: 10.9,
  width: 1.1,
  height: 20.3
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 15.2,
  y: 28.5,
  width: 11.6,
  height: 0.3
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 15.2,
  y: 13.2,
  width: 11.6,
  height: 0.3
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "21.1 10 21.1 12.1 21.2 12.1 21.2 10 22.2 10.7 22.2 10.7 21.2 9.9 21.1 9.9 21.1 9.9 20 10.7 20.1 10.7 21.1 10"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "21.2 32 21.2 29.9 21.1 29.9 21.1 32 20.1 31.3 20 31.3 21.1 32.1 21.1 32.1 21.2 32.1 22.2 31.3 22.2 31.3 21.2 32"
})));

function SvgIconElevatorInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElevatorInactive);
export default __webpack_public_path__ + "static/media/icon_elevator_inactive.bec74e6c.svg";
export { ForwardRef as ReactComponent };